import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "eyeIcon", "eyeSlashIcon", "submitButton"]

  connect() {
    this.boundHandleClick = this.handleSubmitClick.bind(this);
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.addEventListener("click", this.boundHandleClick);
    }
  }

  disconnect() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.removeEventListener("click", this.boundHandleClick);
    }
  }

  handleSubmitClick() {
    // Handle multiple password inputs
    this.inputTargets.forEach((input, index) => {
      if (input.type === "text") {
        const eyeIcon = this.eyeIconTargets[index];
        const eyeSlashIcon = this.eyeSlashIconTargets[index];
        input.type = "password";
        eyeIcon.classList.remove("hidden");
        eyeSlashIcon.classList.add("hidden");
      }
    });
  }

  toggle(event) {
    // Find which toggle button was clicked by traversing up to find the password field container
    const button = event.currentTarget;
    const container = button.closest('.relative');
    const input = container.querySelector('[data-password-visibility-target="input"]');
    const eyeIcon = button.querySelector('[data-password-visibility-target="eyeIcon"]');
    const eyeSlashIcon = button.querySelector('[data-password-visibility-target="eyeSlashIcon"]');

    if (input.type === "password") {
      input.type = "text";
      eyeIcon.classList.add("hidden");
      eyeSlashIcon.classList.remove("hidden");
    } else {
      input.type = "password";
      eyeIcon.classList.remove("hidden");
      eyeSlashIcon.classList.add("hidden");
    }
  }
}
